export type Entity = {
  destinationId: string;
  name: string;
  code: string;
  latitude?: number;
  longitude?: number;
  tts: boolean;
  type: "CITY" | "AIRPORTGROUP" | "HOTEL" | "REGION" | "LANDMARK" | "COUNTRY";
  useSPABookingFlow?: boolean;
  ttsDestinationCode?: string;
  ttsHotelCode?: string;
  cubaDestination: boolean;
};

type Suggestion = {
  entities: Entity[];
  group:
    | "AIRPORT_GROUP"
    | "CITY_GROUP"
    | "LANDMARK_GROUP"
    | "REGION_GROUP"
    | "COUNTRY_GROUP";
};

export type Suggestions = {
  suggestions: Suggestion[];
  term: string;
};

const MERGED_GROUP = ["CITY_GROUP", "REGION_GROUP", "COUNTRY_GROUP"];

const ORDERED_GROUPS = [
  "MERGED_GROUP",
  "LANDMARK_GROUP",
  "AIRPORT_GROUP",
  "HOTEL_GROUP",
];

const groupSuggestions = (jsonSuggest: Suggestions) => {
  const formatted: { [key: string]: Entity[] } = {};
  const orderedFormatted: { [key: string]: Entity[] } = {};
  jsonSuggest.suggestions.forEach(({ entities, group }: Suggestion) => {
    if (MERGED_GROUP.includes(group)) {
      formatted["MERGED_GROUP"] = (formatted["MERGED_GROUP"] || []).concat(
        entities
      );
    } else {
      formatted[group] = (formatted[group] || []).concat(entities);
    }
  });

  ORDERED_GROUPS.forEach((group) => {
    if (formatted[group]) {
      orderedFormatted[group] = formatted[group];
    }
  });
  return orderedFormatted;
};

export const isValidSuggestions = (jsonSuggest: Suggestions): boolean => {
  return jsonSuggest.suggestions.every(
    (suggestion) => suggestion.entities && suggestion.group
  );
};

export default groupSuggestions;
